var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimesheetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#597CA5",
    d: "M5 1v2H2v17h8.135a7.412 7.412 0 01-.559-2H4V8h14v1.576c.7.095 1.373.282 2 .559V3h-3V1h-2v2H7V1zm1 9v2h2v-2zm4 0v2h1.438a7.59 7.59 0 01.562-.563V10zm4 0v.135c.112-.05.227-.091.342-.135z",
    opacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#597CA5",
    strokeWidth: 1,
    d: "M17 11c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-.799 2.8H17.5v3.206l2.777 1.668-.693 1.12-3.383-2.083z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetIcon);
export default __webpack_public_path__ + "static/media/TimesheetIcon.a2124943b77ad0d3a2a76c7d1bffaa9b.svg";
export { ForwardRef as ReactComponent };